(function () {
    const INTERVALO_ACTUALIZACION_MS = 5 * 60 * 1000;
    const ESPERA_FILTROS_MS = 500;
    const FILAS_ESQUELETO = 6;

    /**
     * Pinta filas "esqueleto" (shimmer) mientras carga una tabla, en vez de
     * bloquear toda la pantalla con el spinner global.
     */
    window.mostrarFilasEsqueleto = function (tableBody, numColumnas, numFilas = FILAS_ESQUELETO) {
        if (!tableBody) return;
        const filas = [];
        for (let i = 0; i < numFilas; i++) {
            const celdas = Array.from({ length: numColumnas })
                .map(() => `<td><span class="skeleton-bar"></span></td>`)
                .join("");
            filas.push(`<tr class="fila-esqueleto" aria-hidden="true">${celdas}</tr>`);
        }
        tableBody.innerHTML = filas.join("");
    };

    /**
     * Coordina la carga inicial, el refresco periódico y el debounce de filtros.
     * La función consultar recibe un AbortSignal y un indicador de si se trata
     * de un refresco silencioso (periódico), para que cada tabla decida si
     * muestra el esqueleto de carga o actualiza sin parpadear.
     */
    window.crearActualizadorApi = function (consultar) {
        let temporizadorFiltro = null;
        let temporizadorActualizacion = null;
        let controlador = null;
        let numeroConsulta = 0;

        const programarSiguienteActualizacion = () => {
            clearTimeout(temporizadorActualizacion);
            temporizadorActualizacion = setTimeout(
                () => ejecutarAhora({ esRefrescoSilencioso: true }),
                INTERVALO_ACTUALIZACION_MS
            );
        };

        const ejecutarAhora = async ({ esRefrescoSilencioso = false } = {}) => {
            clearTimeout(temporizadorFiltro);
            clearTimeout(temporizadorActualizacion);

            if (controlador) {
                controlador.abort();
            }

            const consultaActual = ++numeroConsulta;
            controlador = new AbortController();

            try {
                await consultar(controlador.signal, { esRefrescoSilencioso });
            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error("Error en la solicitud:", error);
                }
            } finally {
                if (consultaActual === numeroConsulta) {
                    controlador = null;
                    programarSiguienteActualizacion();
                }
            }
        };

        const ejecutarAlTerminarFiltro = () => {
            clearTimeout(temporizadorFiltro);
            clearTimeout(temporizadorActualizacion);

            // La respuesta en curso ya no corresponde a los filtros visibles.
            numeroConsulta += 1;
            if (controlador) {
                controlador.abort();
                controlador = null;
            }

            temporizadorFiltro = setTimeout(
                () => ejecutarAhora({ esRefrescoSilencioso: false }),
                ESPERA_FILTROS_MS
            );
        };

        const detener = () => {
            numeroConsulta += 1;
            clearTimeout(temporizadorFiltro);
            clearTimeout(temporizadorActualizacion);
            if (controlador) {
                controlador.abort();
                controlador = null;
            }
        };

        window.addEventListener("pagehide", detener);
        window.addEventListener("spray:datos-actualizados", () => ejecutarAhora());
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                ejecutarAhora();
            }
        });

        return {
            iniciar: () => ejecutarAhora(),
            actualizarAhora: () => ejecutarAhora(),
            alCambiarFiltro: ejecutarAlTerminarFiltro,
            detener,
        };
    };
})();
